export default function relativePercentageDiff(a: string | number, b: string | number) {
  const initValue = +a;
  const changeValue = +b;
  if (Number.isNaN(initValue) || Number.isNaN(changeValue)) {
    return false;
  }
  return changeValue - initValue === 0 ? 0 : (100 * (changeValue - initValue)) / initValue;
}
